import {
    STATUT_A_DESSAISIR,
    STATUT_INVALIDE,
    STATUT_TITRE_DETENTION,
    STATUT_VALIDE,
    TYPE_DEMARCHE,
} from 'constants/titreDetention.constants';
import React, { useEffect, useMemo } from 'react';
import { LoaderMi } from '@design-system-etat/dsfr-react';

import { useDispatch, useSelector } from 'react-redux';
import { getAPI } from 'store/apiReducer';
import usagerClientReducer from 'store/usagerReducer';
import { getDateFRFromYYYYMMDDHHMMSS } from 'components/Commun/Form/Date/dateTranformation';
import SimpleTable from 'components/Commun/Table/SimpleTable';
import {
    API_GET_MES_AUTORISATIONS,
    CONTEXT_MES_AUTORISATIONS,
} from '../../../../../constants/apiUrls.constants';
import TitreDetentionTelechargementBouton from '../boutonTelechargementTitreDetention/TitreDetentionTelechargementBouton';

const MesAutorisations = () => {
    const dispatch = useDispatch();

    const { isLoading, data: autorisations } = useSelector(
        (state) => state.mesDemarchesEtAutorisations.mesAutorisations,
    );
    const { titreDetentions } = autorisations ?? {};

    const boutonActionsTitreDetention = (titre) => {
        if (
            [STATUT_A_DESSAISIR, STATUT_VALIDE].includes(titre.statut) ||
            (titre.statut === STATUT_INVALIDE && titre.motifRefus)
        ) {
            return <TitreDetentionTelechargementBouton titreDetention={titre} />;
        }
        return <></>;
    };

    useEffect(() => {
        dispatch(getAPI(usagerClientReducer, API_GET_MES_AUTORISATIONS, CONTEXT_MES_AUTORISATIONS));
    }, []);

    const mesAutorisations = useMemo(() => {
        const listeAutorisations = [];
        if (Array.isArray(titreDetentions)) {
            titreDetentions.forEach((titreDetention) => {
                const { typeTitreDetention, numero, statut, dateDebut } = titreDetention;
                listeAutorisations.push([
                    TYPE_DEMARCHE[typeTitreDetention],
                    numero,
                    STATUT_TITRE_DETENTION[statut],
                    getDateFRFromYYYYMMDDHHMMSS(dateDebut),
                    boutonActionsTitreDetention(titreDetention),
                ]);
            });
        }

        return listeAutorisations;
    }, [titreDetentions]);

    const header = [
        'Type de démarche',
        'Numéro de dossier',
        'Statut',
        'Date de dépôt de la demande',
        'Actions',
    ];

    const donneesVides = [['Aucune démarche en cours', '', '', '', '']];

    return (
        <>
            {isLoading && <LoaderMi />}

            <SimpleTable
                entete={header}
                isLoading={isLoading}
                donnees={
                    Array.isArray(mesAutorisations) && mesAutorisations.length
                        ? mesAutorisations
                        : donneesVides
                }
                boutonActionsPresent
            />
        </>
    );
};

export default MesAutorisations;
